<app-dialog-header>
  <h2>{{ i18n.get('text') }}</h2>
</app-dialog-header>
<app-dialog-body>
  <mat-form-field appearance="outline">
    <textarea matInput placeholder="{{ i18n.get('yourText') }}" [(ngModel)]="text"></textarea>
  </mat-form-field>
</app-dialog-body>
<app-dialog-footer>
  <button mat-stroked-button (click)="cancel()">
    {{ i18n.get('cancel') }}
  </button>
  <button mat-flat-button color="primary" (click)="submit()">
    {{ i18n.get('ok') }}
  </button>
</app-dialog-footer>
